export default __webpack_public_path__ + "static/equilibre_illustration_ad-99c08461a8706d2f2468a942118ce429.png";